import './Zone.css';
import {useContext} from "react";
import {ZonesContext} from "../AppContext";

export default function Zone(props) {
    const zoneContext = useContext(ZonesContext);

    function click() {
        if (props.zone.selectable && !props.zone.locked) {
            zoneContext.toggleZone(props.zoneId, props.zone);
            document.getElementById('pricing-table-button').classList.add('active');
            document.querySelector('.helper').style.opacity = 0;
            document.querySelector('.map-wrapper img').style.opacity = 1;
            document.querySelectorAll('.zone').forEach((item) => {
              item.style.animation = 'unset'
            })
            document.querySelector('[data-zone="10"]').classList.remove('fade')
        }
    }

    function getClasses() {
        let classes = ['zone'];
        if (props.zone.selected) {
            classes.push('selected');
        }
        if(props.zone.selectable) {
            props.zone.selectable ?? classes.push('selectable');
        }
        if(!props.zone.selectable && !props.zone.selected) {
            classes.push('disabled');
        }

        if(props.zoneId === '10' && !props.zone.selected) {
          classes.push('fade')
        }

        return classes.join(' ');
    }

    switch (props.zone.tag) {
        case 'polyline':
            return <polyline onClick={click} data-zone={props.zoneId} class={getClasses()}
                             points={props.zone.svgData}></polyline>
        case 'path':
            return <path onClick={click} data-zone={props.zoneId} class={getClasses()}
                         d={props.zone.svgData}></path>
        default:
            return <polygon onClick={click} data-zone={props.zoneId} class={getClasses()}
                            points={props.zone.svgData}></polygon>
    }
}
